import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import DropdownControl from "../dropdown/DropdownControl";

interface Props {
  enableModal: boolean,
  onChange: (value: boolean) => void,
  onSubmit: () => void,
  onClose: () => void,
  isPublic?: boolean
}

const itemsTitles = {
    publicTitle: 'Anyone who has the preview link',
    privateTitle: 'Only people with a moderator role or above'
}

const dropdownItems = (items: Array<string>, callback: CallableFunction) => items.map(item => ({
    title: item,
    onClick: (e: ClickEvent) => callback(e.target.textContent == itemsTitles.publicTitle)
}))

const items = {
    isPrivate: itemsTitles.privateTitle,
    isPublic: itemsTitles.publicTitle
}

const ArticlePreviewModal = (props: Props) => {
  const {
    enableModal,
    onChange,
    onSubmit,
    onClose,
    isPublic
  } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title='Share Setting' onClose={onClose} />
      <ModalBody>
          <div class="preview-access">
          <DropdownControl
              align='adjust'
              items={dropdownItems([items.isPrivate, items.isPublic], onChange)}
              trigger={<ButtonControl icon={'arrowDropdown'} title={isPublic ? items.isPublic : items.isPrivate} class={'preview-access-dropdown qa-preview-access-dropdown'}/>}
          /> <span>can access the preview</span>
          </div>
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Save' variant='success' onClick={onSubmit} class='qa-preview' />
        <ButtonControl title='Cancel' onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export default ArticlePreviewModal
